// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalBiResultSearchDefaultResponseData {
    static getAttributeTypeMap() {
        return MedicalV1MedicalBiResultSearchDefaultResponseData.attributeTypeMap;
    }
}
MedicalV1MedicalBiResultSearchDefaultResponseData.discriminator = undefined;
MedicalV1MedicalBiResultSearchDefaultResponseData.additionalProperties = false;
MedicalV1MedicalBiResultSearchDefaultResponseData.attributeTypeMap = [
    {
        "name": "additionalNotes",
        "baseName": "additionalNotes",
        "type": "string"
    },
    {
        "name": "annualCapExist",
        "baseName": "annualCapExist",
        "type": "boolean"
    },
    {
        "name": "benefitNetworkStatus",
        "baseName": "benefitNetworkStatus",
        "type": "string"
    },
    {
        "name": "benefitsNotes",
        "baseName": "benefitsNotes",
        "type": "string"
    },
    {
        "name": "buyAndBillAvailable",
        "baseName": "buyAndBillAvailable",
        "type": "boolean"
    },
    {
        "name": "claimAddress",
        "baseName": "claimAddress",
        "type": "string"
    },
    {
        "name": "coInsurance",
        "baseName": "coInsurance",
        "type": "string"
    },
    {
        "name": "coordinationOfBenefits",
        "baseName": "coordinationOfBenefits",
        "type": "string"
    },
    {
        "name": "createdTimestamp",
        "baseName": "createdTimestamp",
        "type": "Date"
    },
    {
        "name": "deductibleIncludedInOop",
        "baseName": "deductibleIncludedInOop",
        "type": "boolean"
    },
    {
        "name": "followsMedicareGuidelines",
        "baseName": "followsMedicareGuidelines",
        "type": "string"
    },
    {
        "name": "multipleCopay",
        "baseName": "multipleCopay",
        "type": "boolean"
    },
    {
        "name": "reasonForNonCoverage",
        "baseName": "reasonForNonCoverage",
        "type": "string"
    },
    {
        "name": "requestId",
        "baseName": "requestId",
        "type": "number"
    },
    {
        "name": "resultId",
        "baseName": "resultId",
        "type": "number"
    },
    {
        "name": "reviewRequired",
        "baseName": "reviewRequired",
        "type": "boolean"
    },
    {
        "name": "taskStatus",
        "baseName": "taskStatus",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "updatedTimestamp",
        "baseName": "updatedTimestamp",
        "type": "Date"
    },
    {
        "name": "appeal",
        "baseName": "appeal",
        "type": "MedicalBiAppeal"
    },
    {
        "name": "copay",
        "baseName": "copay",
        "type": "MedicalBiCopay"
    },
    {
        "name": "denial",
        "baseName": "denial",
        "type": "MedicalBiDenial"
    },
    {
        "name": "facility",
        "baseName": "facility",
        "type": "MedicalBiFacility"
    },
    {
        "name": "family",
        "baseName": "family",
        "type": "MedicalBiFamily"
    },
    {
        "name": "individual",
        "baseName": "individual",
        "type": "MedicalBiIndividual"
    },
    {
        "name": "lifetime",
        "baseName": "lifetime",
        "type": "MedicalBiLifetime"
    },
    {
        "name": "medical",
        "baseName": "medical",
        "type": "MedicalBiMedical"
    },
    {
        "name": "obtainPreDetermination",
        "baseName": "obtainPreDetermination",
        "type": "MedicalBiObtainPreDetermination"
    },
    {
        "name": "obtainPriorAuthorization",
        "baseName": "obtainPriorAuthorization",
        "type": "MedicalBiObtainPriorAuthorization"
    },
    {
        "name": "patient",
        "baseName": "patient",
        "type": "MedicalBiPatient"
    },
    {
        "name": "payor",
        "baseName": "payor",
        "type": "MedicalBiPayor"
    },
    {
        "name": "pbm",
        "baseName": "pbm",
        "type": "MedicalBiPbm"
    },
    {
        "name": "pcp",
        "baseName": "pcp",
        "type": "MedicalBiPcp"
    },
    {
        "name": "peerToPeer",
        "baseName": "peerToPeer",
        "type": "MedicalBiPeerToPeer"
    },
    {
        "name": "practice",
        "baseName": "practice",
        "type": "MedicalBiPractice"
    },
    {
        "name": "preDetermination",
        "baseName": "preDetermination",
        "type": "MedicalBiPreDetermination"
    },
    {
        "name": "preferredSpecialty",
        "baseName": "preferredSpecialty",
        "type": "MedicalBiPreferredSpecialty"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MedicalBiPrescriber"
    },
    {
        "name": "prescription",
        "baseName": "prescription",
        "type": "MedicalBiPrescription"
    },
    {
        "name": "priorAuthorization",
        "baseName": "priorAuthorization",
        "type": "MedicalBiPriorAuthorization"
    },
    {
        "name": "referral",
        "baseName": "referral",
        "type": "MedicalBiReferral"
    },
    {
        "name": "specialtyPharmacy",
        "baseName": "specialtyPharmacy",
        "type": "MedicalBiSpecialtyPharmacy"
    },
    {
        "name": "spendDown",
        "baseName": "spendDown",
        "type": "MedicalBiSpendDown"
    },
    {
        "name": "stepTherapy",
        "baseName": "stepTherapy",
        "type": "MedicalBiStepTherapy"
    },
    {
        "name": "cptCodes",
        "baseName": "cptCodes",
        "type": "Array<MedicalBiDiagnosisCode>"
    },
    {
        "name": "jCodes",
        "baseName": "jCodes",
        "type": "Array<MedicalBiDiagnosisCode>"
    },
];
//# sourceMappingURL=medicalV1MedicalBiResultSearchDefaultResponseData.js.map